// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type SignInCallbackQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  redirectUri: Types.InputMaybe<Types.Scalars['Url']['input']>;
  codeVerifier: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type SignInCallbackQuery = { __typename?: 'Query' } & {
  signInCallback:
    | ({ __typename: 'SignInCallbackError' } & Pick<Types.SignInCallbackError, 'errorCode'>)
    | ({ __typename: 'SignInCallbackSuccess' } & Pick<Types.SignInCallbackSuccess, 'accessToken'>);
};

export const SignInCallbackDocument = /*#__PURE__*/ gql`
    query signInCallback($code: String!, $redirectUri: Url, $codeVerifier: String) {
  signInCallback(
    code: $code
    redirectUri: $redirectUri
    codeVerifier: $codeVerifier
  ) {
    __typename
    ... on SignInCallbackSuccess {
      accessToken
    }
    ... on SignInCallbackError {
      errorCode
    }
  }
}
    `;

/**
 * __useSignInCallbackQuery__
 *
 * To run a query within a React component, call `useSignInCallbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignInCallbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignInCallbackQuery({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *      codeVerifier: // value for 'codeVerifier'
 *   },
 * });
 */
export function useSignInCallbackQuery(
  baseOptions: Apollo.QueryHookOptions<SignInCallbackQuery, SignInCallbackQueryVariables> &
    ({ variables: SignInCallbackQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SignInCallbackQuery, SignInCallbackQueryVariables>(SignInCallbackDocument, options);
}
export function useSignInCallbackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SignInCallbackQuery, SignInCallbackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SignInCallbackQuery, SignInCallbackQueryVariables>(SignInCallbackDocument, options);
}
// @ts-expect-error
export function useSignInCallbackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SignInCallbackQuery, SignInCallbackQueryVariables>,
): Apollo.UseSuspenseQueryResult<SignInCallbackQuery, SignInCallbackQueryVariables>;
export function useSignInCallbackSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignInCallbackQuery, SignInCallbackQueryVariables>,
): Apollo.UseSuspenseQueryResult<SignInCallbackQuery | undefined, SignInCallbackQueryVariables>;
export function useSignInCallbackSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignInCallbackQuery, SignInCallbackQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SignInCallbackQuery, SignInCallbackQueryVariables>(SignInCallbackDocument, options);
}
export type SignInCallbackQueryHookResult = ReturnType<typeof useSignInCallbackQuery>;
export type SignInCallbackLazyQueryHookResult = ReturnType<typeof useSignInCallbackLazyQuery>;
export type SignInCallbackSuspenseQueryHookResult = ReturnType<typeof useSignInCallbackSuspenseQuery>;
